import { ComponentProps } from 'react';
import { Badge } from '@Components/Badge';
import { Design, Intent } from '@Components/designConstants';

export const UPDATE_RESTART_STATUSES_MS = 20 * 1000;
export const DATE_TIME_FORMAT = 'yyyy-MM-dd hh:mma';

// Keyed by getDagKey; an entry means a restart is in flight for that build.
export type RestartMap = Record<string, { job_start_time?: string }>;

// AWS Batch job statuses.
export const BATCH_JOB_STATUS = {
  SUBMITTED: 'SUBMITTED',
  PENDING: 'PENDING',
  RUNNABLE: 'RUNNABLE',
  STARTING: 'STARTING',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
} as const;
export type BatchJobStatus = (typeof BATCH_JOB_STATUS)[keyof typeof BATCH_JOB_STATUS];

export const STATUS_BADGE_DESIGN: Record<
  BatchJobStatus,
  NonNullable<ComponentProps<typeof Badge>['design']>
> = {
  [BATCH_JOB_STATUS.SUCCEEDED]: Intent.SUCCESS,
  [BATCH_JOB_STATUS.FAILED]: Intent.ERROR,
  [BATCH_JOB_STATUS.RUNNING]: Intent.INFO,
  [BATCH_JOB_STATUS.STARTING]: Intent.INFO,
  [BATCH_JOB_STATUS.RUNNABLE]: Intent.WARNING,
  [BATCH_JOB_STATUS.PENDING]: Intent.WARNING,
  [BATCH_JOB_STATUS.SUBMITTED]: Design.NEUTRAL
};
